
import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { REPORTS } from '@/constants/constants';

export default Vue.extend({
	name: 'AppMetricsReport',
	metaInfo () {
		return {
			title: 'RunDiffusion App Usage',
		};
	},
	props: {
		selectedTeam: { type: Object, default: null },
		selectedCompany: { type: Object, default: null },
		defaultTeamMemberEmail: { type: String, default: null },
	},
	data () {
		return {
			// Dashboards
			teamMetricsDashboardUrl: null,
		};
	},
	watch: {
		selectedTeam: {
			immediate: true,
			async handler (newVal, oldVal) {
				if (newVal !== oldVal) {
					await this.loadTeamReportEmbedUrls({ team: newVal, company: this.selectedCompany });
				}
			},
		},
		teamReportEmbedUrlsData: {
			immediate: true,
			handler (newVal, oldVal) {
				if (newVal !== oldVal) {
					// Check for company dashboard (430) first, then team dashboard (397)
					this.teamMetricsDashboardUrl = this._get(newVal, `dashboards[${REPORTS.DASHBOARDS.APP_USAGE_HOURS_COMPANY_DASHBOARD}]`) ||
						this._get(newVal, `dashboards[${REPORTS.DASHBOARDS.APP_USAGE_HOURS_DASHBOARD}]`);
				}
			},
		},
	},
	computed: {
		...mapState([
			'user',
			'teamReportEmbedUrlsData',
			'teamReportEmbedUrlsDataLoading',
		]),
		...mapGetters([
			'displayLabels',
		]),
	},
	methods: {
		...mapActions([
			'loadTeamReportEmbedUrls',
		]),
	},
});
